// Readiness trend (fleet-4): the daily snapshots (readiness_snapshots, written by the 05:00 job with the service key, sql/fleet-4.sql)
// against today's score. Plain JS: tests/fleet-4.test.mjs.
//   now   = the live score (the ring) when given, else the newest snapshot of the last 2 days
//   7 d   = now - the snapshot of 7 days ago (or the closest one up to 3 days older); none -> null ("—")
//   30 d  = the same with the snapshot of 30 days ago (up to 5 days older)
//   spark = the last 30 days of snapshots, oldest first, today's live score last
const DAY = 864e5
const iso = d => new Date(d).toISOString().slice(0, 10)
const dayOf = s => String(s && s.day || '').slice(0, 10)

export function trendFrom(snaps = [], { today, live = null } = {}) {
  const t = Date.parse(today)
  const byDay = new Map()
  for (const s of snaps) { const d = dayOf(s); if (/^\d{4}-\d{2}-\d{2}$/.test(d) && Number.isFinite(+s.score)) byDay.set(d, Math.round(+s.score)) }
  const at = (back, slack) => {
    for (let k = 0; k <= slack; k++) { const d = iso(t - (back + k) * DAY); if (byDay.has(d)) return { day: d, score: byDay.get(d) } }
    return null
  }
  const recent = at(0, 2)
  const now = Number.isFinite(+live) && live != null ? Math.round(+live) : recent ? recent.score : null
  const vs = (back, slack) => { const b = at(back, slack); return b && now != null ? { delta: now - b.score, from: b.score, day: b.day } : null }
  const spark = [...byDay.entries()].filter(([d]) => Date.parse(d) > t - 30 * DAY && Date.parse(d) < t).sort(([a], [b]) => (a < b ? -1 : 1)).map(([day, score]) => ({ day, score }))
  if (now != null) spark.push({ day: iso(t), score: now })
  else if (byDay.has(iso(t))) spark.push({ day: iso(t), score: byDay.get(iso(t)) })
  return { now, d7: vs(7, 3), d30: vs(30, 5), spark }
}

// ▲ +6 / ▼ -4 / ▶ 0 and its tone (a rising score is good)
export function arrowOf(t) {
  if (!t) return { arrow: '—', text: '—', tone: 'none' }
  if (t.delta > 0) return { arrow: '▲', text: '+' + t.delta, tone: 'up' }
  if (t.delta < 0) return { arrow: '▼', text: String(t.delta), tone: 'down' }
  return { arrow: '▶', text: '0', tone: 'flat' }
}

// the sparkline's SVG path over w x h (0-100 score scale, a little padding); fewer than 2 points -> ''
export function sparkPath(points, w = 64, h = 18, pad = 2) {
  if (!points || points.length < 2) return ''
  const xs = points.map((_, i) => pad + (i * (w - 2 * pad)) / (points.length - 1))
  const lo = Math.min(...points.map(p => p.score)), hi = Math.max(...points.map(p => p.score))
  const span = Math.max(10, hi - lo), base = Math.max(0, Math.min(100 - span, (lo + hi) / 2 - span / 2))
  const y = s => h - pad - ((s - base) / span) * (h - 2 * pad)
  return points.map((p, i) => (i ? 'L' : 'M') + xs[i].toFixed(1) + ' ' + y(p.score).toFixed(1)).join(' ')
}
